import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=3c166834"
import script from "./ExpensesList.vue?vue&type=script&lang=js"
export * from "./ExpensesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports